<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <!-- <h5 class="card-title font-weight-bold font-size-lg mb-4">Contract Service</h5> -->
            <form [formGroup]="contractForm">
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="empid">Contract ID*</label>
                            <input id="empid" class="form-control" [readonly]="isEditMode" formControlName="contractID" placeholder="Contract ID" type="text" [ngClass]="{'is-invalid': submitted && f.contractID.errors}">
                            <div *ngFor="let validation of validation_messages.contractID">
                                <div class="error-message" *ngIf="f.contractID.hasError(validation.type) && ((f.contractID.dirty  || f.contractID.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="position-relative form-group">
                            <label for="empid">Contract Type*</label>
                            <ng-select id="contractType" [readonly]="isEditMode" formControlName="contractType" [(ngModel)]="selectedContractType" [ngClass]="{'is-invalid': submitted && f.contractType.errors}" placeholder="Select contract type">
                                <ng-option *ngFor="let contractType of contractTypes" [value]="contractType.ContractID">{{contractType.ContractID}} </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.contractType">
                                <div class="error-message" *ngIf="f.contractType.hasError(validation.type) && ((f.contractType.dirty  || f.contractType.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="form-group">
                            <label for="empid">Amount*</label>
                            <input id="amount" class="form-control" formControlName="amount" placeholder="amount " type="number" [ngClass]="{'is-invalid': submitted && f.amount.errors}" (ngModelChange)="amountChangeCheckingFn(f.amount)">
                            <div *ngFor="let validation of validation_messages.amount">
                                <div class="error-message" *ngIf="f.amount.hasError(validation.type) && ((f.amount.dirty  || f.amount.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="empid">Status*</label>
                            <ng-select  id="active" required formControlName="active" [ngClass]="{'is-invalid': submitted && f.active.errors}" placeholder="Select Status">
                                <ng-option *ngFor="let status of statusTypes" [value]="status.id">
                                    {{status.name}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
        </div>
        <div class="row">            
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="sd">Short Description*</label>
                            <input id="sd" class="form-control" formControlName="shortDescription" placeholder="Short Description" type="text" [ngClass]="{'is-invalid': submitted && f.shortDescription.errors}">
                            <div *ngFor="let validation of validation_messages.shortDescription">
                                <div class="error-message" *ngIf="f.shortDescription.hasError(validation.type) && ((f.shortDescription.dirty  || f.shortDescription.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                            <label for="ld">Long Description*</label>
                            <input id="ld" class="form-control" formControlName="longDescription" placeholder="longDescription ID" type="text" [ngClass]="{'is-invalid': submitted && f.longDescription.errors}">
                            <div *ngFor="let validation of validation_messages.longDescription">
                                <div class="error-message" *ngIf="f.longDescription.hasError(validation.type) && ((f.longDescription.dirty  || f.longDescription.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-3" *ngIf="isEditMode && isAmountChanged">
                        <label for="inputEmail4">Effective Start Date</label>

                        <input id="effectsDate" [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true}" 
                        bsDatepicker  formControlName="effectsDate" class="form-control"
                        placeholder="Select start date">
                       
                        <div *ngFor="let validation of validation_messages.effectsDate">
                            <div class="error-message"
                                *ngIf="f.effectsDate.hasError(validation.type) && 
                                                                   ((f.effectsDate.dirty ||  f.effectsDate.touched))">
                                {{validation.message }}
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-md-3" *ngIf="!isEditMode">
                        <label for="inputEmail4">Effective Start Date</label>

                        <input id="effectsDate" [bsConfig]="{ containerClass: 'theme-primary', isAnimated: true}" 
                        bsDatepicker  formControlName="effectsDate" class="form-control"
                        placeholder="Select start date">
                       
                        <div *ngFor="let validation of validation_messages.effectsDate">
                            <div class="error-message"
                                *ngIf="f.effectsDate.hasError(validation.type) && 
                                                                   ((f.effectsDate.dirty ||  f.effectsDate.touched))">
                                {{validation.message }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="stations">Stations *</label>
                            <ng-select *ngIf="!isEditMode" id="stations" [multiple]="true" required formControlName="stations" [ngClass]="{'is-invalid': submitted && f.stations.errors}" placeholder="Select Station" (change)="onStationChange($event)">
                                <!-- <ng-option [value]="'ALL'">
                                    ALL
                                </ng-option> -->
                                <ng-option *ngFor="let station of allStations" [value]="station.stationid">
                                    {{station.stationid}} - {{station.airportName}}
                                </ng-option>
                            </ng-select>
                                 <ng-select *ngIf="isEditMode" id="stations" [multiple]="true"  [readonly]="isEditMode"  required formControlName="stations" [ngClass]="{'is-invalid': submitted && f.stations.errors}" placeholder="Select Station" (change)="onStationChange($event)">
                                <ng-option   *ngFor="let station of allStations" [value]="station.stationid">
                                    {{station.stationid}} - {{station.airportName}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.stations">
                                <div class="error-message" *ngIf="f.stations.hasError(validation.type) && 
                                                                        ((f.stations.dirty || f.stations.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 py-3">
                        <!-- <button id="backBtn" class="btn btn m-2 btn-neutral-primary btn-square" type="button" (click)="onBack()">Back</button> -->
                        <button id="saveContractBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddContract(contractForm.value)" *ngIf="!isEditMode">Add Contract</button>
                        <button id="updateContractBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateContract(contractForm.value)" *ngIf="isEditMode">Update Contract </button>
                        <!-- <button id="resetBtn" class="btn m-2 btn-dark btn-square" type="button" (click)="onRest()">Reset</button> -->
                    </div>
                </div>
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>